import gql from 'graphql-tag';

export const GET_EVENT_ATTENDEE = gql`
  query GetEventAttendee(
    $userId: ID
    $eventId: ID
    $cachedSlug: String
    $id: Int
    $visibleToUser: Boolean
  ) {
    eventAttendee(
      userId: $userId
      eventId: $eventId
      cachedSlug: $cachedSlug
      id: $id
      visibleToUser: $visibleToUser
    ) {
      id
      currentState
      source
      skipPayment
      totalTicketCost
      hasAppliedPromoCode
      visibleToUser
      occasion
      occasionDetails
      tickets {
        id
        firstName
        lastName
        email
        primary
      }
    }
  }
`;
